/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Event listener to add gift wrap to cart
document.addEventListener('click', function(event) {
  if(event.target.matches('button[data-action="add-gift-wrap"]')) {
     console.log('gift button clicked', event.target)
     
     
     fetch(window.theme.localeRootUrl + '/cart/add.js', {
       body: JSON.stringify({items: [{quantity: 1, id: 10314372231}]}),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
     
     
     
     
     
    event.preventDefault();
     }
})

// Event listener to add shippping insurance to cart
document.addEventListener('input', function(event){
  console.log('an input event')
  if(event.target.id !== 'shipping_insurance') return;
  console.log('shipping change', event.target.value);
  fetch(window.theme.localeRootUrl + '/cart/add.js', {
       body: JSON.stringify({items: [{quantity: 1, id: event.target.value}]}),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
     
    event.preventDefault();
})

// When a variant is changed, we force a reload with the new variant id to update the recharge options
document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    var pathname = window.location.pathname
    window.location.replace(pathname + '?variant=' + variant.id)
  });

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

var faqSection = document.getElementById("faqs");
var currentPage = window.location.pathname;
if(currentPage == "/pages/faq"){
var faqLinks = faqSection.getElementsByTagName('a');
for (let j = 0, faqLinksLength = faqLinks.length ; j < faqLinksLength ; j++) {
    faqLinks[j].target = '_blank';
    faqLinks[j].rel = 'noreferrer noopener';
  }
}

//add an event to update the shipping when cart is refreshed
document.addEventListener('product:added', function(event) {
  if (hextom_fsb_instance) {
    hextom_fsb_instance = hextom_fsb();
  }
});

document.addEventListener('theme:loading:end', function(event) {
  if (hextom_fsb_instance) {
    hextom_fsb_instance = hextom_fsb();
  }
});